import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
// direct import
import { useStyles } from "../profile/style";
const Loader = () => {
  const classes = useStyles();
  return (
    <>
      <Skeleton
        variant="circular"
        width={110}
        height={110}
        className={classes.avatar}
        style={{ marginTop: 35, borderRadius: "50%" }}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Skeleton
          variant="text"
          width="40%"
          height={30}
          style={{ borderRadius: 6 }}
        />
        <Skeleton
          variant="text"
          width="40%"
          height={30}
          style={{ borderRadius: 6 }}
        />
      </Box>
      <Skeleton
        variant="rect"
        width="100%"
        height={50}
        style={{ marginTop: 16, borderRadius: 6 }}
      />
      <Skeleton
        variant="rect"
        width="100%"
        height={50}
        style={{ marginTop: 8, borderRadius: 6 }}
      />
      <Skeleton
        variant="rect"
        width="100%"
        height={"50vh"}
        style={{ marginTop: 16, borderRadius: 6 }}
      />
    </>
  );
};
export default Loader;
